<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                           :titleLabel="$t('profile.label.sendMailInfoFlg.edit')"
                           :parentScreen="parentScreen">
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">
                {{$t('profile.label.sendMailInfoFlg.note')}}
            </label>
            <div class="col-md-6">
                <div class="checkboxThree">
                    <input type="checkbox"
                           v-model="$v.input['amsCustomerDetail.sendMailInfoFlg'].$model"
                           name="sendMailInfoFlg"
                           true-value="1"
                           false-value="0"
                           id="ckSendMailInfo"
                    >
                    <label class="form-check-label" for="ckSendMailInfo"></label>
                </div>
            </div>
        </div>
        <div class="alert alert-warning">
            {{$t('profile.label.sendMailInfoFlg.warning')}}
        </div>
        <template v-if="this.isParentScreenEditProfile">
            <div class="form-action">
                <button class="btn btn-sm btn-submit btn-success mr-2"
                        :disabled="isDisabledButtonSubmit"
                        :type="this.getButtonType()">
                    {{$t('profile.button.submit')}}
                </button>
                <button class="btn btn-default btn-cancel btn-sm"
                        type="button"
                        @click="reverseInput">
                    {{$t('profile.button.cancel')}}
                </button>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>
<script>
    /**
     * @author HungNS
     */
    import formMixin from '@/common/mixins/form';
    export default {
        name: "SendMailInformation",
        props: {},
        mixins: [formMixin],
        methods: {},
        validations() {
            return {
                input: {
                    'amsCustomerDetail.sendMailInfoFlg': {}
                }
            }
        }
    }
</script>

<style scoped>

</style>
